<!-- 积分详情 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="用户ID：">
        <el-input placeholder="输入用户ID" @change="getTableList()" v-model="params.userId"></el-input>
      </el-form-item>
      <el-form-item label="网关：">
        <el-input placeholder="输入网关" @change="getTableList()" v-model="params.netBarAccount"></el-input>
      </el-form-item>
      <el-form-item label="时间段：">
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="昵称" prop=""></el-table-column>
      <el-table-column label="用户ID" prop="userId"></el-table-column>
      <el-table-column label="网关" prop="netBarAccount"></el-table-column>
      <el-table-column label="变动时间" prop="createTime"></el-table-column>
      <el-table-column label="变动名称" prop="pointContent"></el-table-column>
      <el-table-column label="变动数量" prop="pointValue">
        <!-- <template slot-scope="scope">
          {{( scope.row.pointType != 2 ? '+' : '-') + scope.row.pointValue }}
        </template> -->
      </el-table-column>
      <el-table-column label="积分剩余" prop="totalPoint"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
  </div>
</template>
 
<script>
  export default {
    data() {
      //这里存放数据
      return {
        time:'',
        params:{
          netBarAccount: '',
          userId: '',
          startTime: '',
          endTime: '',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        tableData:[],
      };
    },
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.integralDetails.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      dateChange(value) {
        this.params.startTime = value[0];
        this.params.endTime = value[1];
      },
      resetParams(){
        this.params={
          netBarAccount: '',
          userId: '',
          startTime: '',
          endTime: '',
          pageNum: 1,
          pageSize: 10
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      if (this.$route.query.userId){
          this.params.userId = this.$route.query.userId;
      }  
      this.getTableList();
    },
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/userManage/integralDetails/integralDetails.vue